import { Country } from '@precheckin/models/country.model';
import { Nationality } from '@precheckin/models/nationality.model';

export interface IPreCheckinCountriesNationalitiesStateModel {
  isPreCheckinCountryNationalityReady: boolean;
  countries: Country[];
  nationalities: Nationality[];
}

export const defaultCountriesNationalitiesState: IPreCheckinCountriesNationalitiesStateModel =
  {
    isPreCheckinCountryNationalityReady: false,
    countries: new Array<Country>(),
    nationalities: new Array<Nationality>()
  };
